module.exports = __webpack_public_path__ + "img/back_B.462fdcb4.png";